export const sizes = {
  xl: {
    h: '82px',
    minW: '82px',
    fontSize: '2xl',
  },
  lg: {
    h: '72px',
    minW: '72px',
    fontSize: 'xl',
  },
  md: {
    h: '64px',
    minW: '64px',
    fontSize: 'lg',
  },
  def: {
    h: '56px',
    minW: '56px',
    fontSize: 'md',
  },
  sm: {
    h: '48px',
    minW: '48px',
    fontSize: 'sm',
  },
  xs: {
    h: '40px',
    minW: '40px',
    fontSize: '0.85rem',
  },
  '2xs': {
    h: '32px',
    minW: '32px',
    fontSize: '0.8rem',
  },
  '3xs': {
    h: '28px',
    minW: '28px',
    fontSize: 'xs',
  },
  '4xs': {
    h: '24px',
    minW: '24px',
    fontSize: '0.7rem',
  },
  '5xs': {
    h: '20px',
    minW: '20px',
    fontSize: '0.675rem',
  },
};
